import React, {forwardRef, useEffect} from "react";
import ListItem from '@mui/material/ListItem';
import {useNavigate} from 'react-router-dom';

const MenuItemComponent = (props) => {
    let navigate = useNavigate();
    const {onClick, uri, children, level} = props;

    const handleClick = uri => e => {
        navigate(`${uri}`);
    }
    
    if (!uri || typeof uri !== "string") {
        return (
            <ListItem
                button
                children={children}
                onClick={onClick}
            />
        );
    }

    return (
        <ListItem
            button
            children={children}
            sx={{pl: level * 2}}
            onClick={handleClick(uri)}
        />
    );
};

export default MenuItemComponent;
